

export class FormatNameUtils {

    static customerDisplayName(
        firstName: string | undefined,
        lastName: string | undefined,
        companyName: string | undefined,
        isCommercial: boolean = false
    ): string {
        return this.getCustomerDisplayName(
            isCommercial,
            companyName ?? "",
            lastName ?? "",
            firstName ?? ""
        );
    }

    static getCustomerDisplayName(
        isCommercial: boolean,
        companyName: string,
        lastName: string,
        firstName: string
    ): string {
        return isCommercial
            ? this.businessDisplayName(companyName, lastName, firstName)
            : this.personDisplayName(lastName, firstName);
    }

    static hasLastAndFirstName(lastName: string, firstName: string): boolean {
        return (lastName.trim() + firstName.trim()).length === 0;
    }

    static businessDisplayName(
        businessName: string,
        lastName: string,
        firstName: string
    ): string {
        return (
            businessName + (this.hasLastAndFirstName(lastName, firstName) ? "" : ": ") +
            this.personDisplayName(lastName, firstName)
        );
    }

    static personDisplayName(lastName: string, firstName: string): string {
        return lastName + (firstName ? ", " : "") + firstName;
    }

}